import { GIFT_CARD } from '~/const/gift-card';
import { CATEGORY_INFIX, EDITO_INFIX, PRODUCT_INFIX, STATIC_INFIX, SEARCH_INFIX } from '~/const/infix';
import USE_MERCURE from '~/const/mercure';
var buildHomeUrl = locale => "/".concat(locale.market, "/").concat(locale.language);
var CgvType = {
  default: 'cgv',
  pro: 'cgv-pro'
};
var CguType = {
  FR: {
    default: 'cgu-acheteurs-marketplace',
    pro: 'cgu-acheteurs-marketplace-business'
  },
  ES: {
    default: 'cgu-compradores-marketplace',
    pro: 'cgu-compradores-marketplace-business'
  },
  IT: {
    default: 'cgu-marketplace ',
    pro: 'cgu-marketplace-business '
  },
  DE: {
    default: 'agb-verkäufer-marketplace',
    pro: 'agb-marketplace-business'
  }
};
var buildCategoryUrl = (locale, slug, hash) => "/".concat(locale.market, "/").concat(locale.language, "/").concat(CATEGORY_INFIX, "/").concat(slug, "-").concat(hash);
var buildProductUrl = (locale, slug, reference, offer) => {
  var url = "/".concat(locale.market, "/").concat(locale.language, "/").concat(PRODUCT_INFIX, "/").concat(slug, "-").concat(reference, ".htm");
  if (offer) {
    url = "".concat(url, "?offer=").concat(offer);
  }
  return url;
};
var buildGiftCardUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/gc/").concat(GIFT_CARD[locale.iso].eGift);
var buildCustomProductUrl = (locale, reference) => "/".concat(locale.market, "/").concat(locale.language, "/configurator/product/").concat(reference);
var buildStaticUrl = (locale, slug, oldVersion) => {
  if (oldVersion) {
    // handle WEB static pages url until they switch to nuxt
    return "/".concat(locale.market, "/").concat(locale.language, "/").concat(slug);
  }
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(STATIC_INFIX, "/").concat(slug);
};
var buildSearchUrl = (locale, query) => "/".concat(locale.market, "/").concat(locale.language, "/").concat(SEARCH_INFIX, "/").concat(query);
var buildEditoUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/").concat(page);
var buildMyAccountUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/user");
var buildFaqUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/help/faq/").concat(page);
var buildContactFormUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/help/contact/").concat(page);
var buildReturnFormUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/help/return/").concat(page);
var buildCgvUrl = (locale, isPro) => "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/legal/").concat(CgvType[isPro ? 'pro' : 'default']);
var buildCguUrl = (locale, isPro) => {
  if (!CguType[locale.market]) return null; // if url market undefined, return blank url

  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/legal/").concat(CguType[locale.market][isPro ? 'pro' : 'default']);
};
var buildShippingUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/shipping");
var buildPaymentUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/payment");
var buildMkpConfirmationUrl = locale => {
  console.log("/".concat(locale.market, "/").concat(locale.language, "/t/confirmation"));
  return "/".concat(locale.market, "/").concat(locale.language, "/t/confirmation");
};
var buildPaymentPaypalPendingUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/payment-paypal-pending");
var buildPaymentPaypalCanceledUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/payment-paypal-canceled");
var buildPaymentConfirmedUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/confirmed");
var buildPaymentRefusedUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/refused");
var buildMerchantUrl = (locale, reference) => "/".concat(locale.market, "/").concat(locale.language, "/m/").concat(reference);
var buildCartUrl = locale => USE_MERCURE(locale.iso) ? "/".concat(locale.market, "/").concat(locale.language, "/cart") : "/".concat(locale.market, "/").concat(locale.language, "/panier.html");
var buildLoginUrl = (locale, isTunnel) => isTunnel ? "/".concat(locale.market, "/").concat(locale.language, "/t/login") : "/".concat(locale.market, "/").concat(locale.language, "/login");
var buildSignupUrl = (locale, isTunnel) => isTunnel ? "/".concat(locale.market, "/").concat(locale.language, "/t/signup") : "/".concat(locale.market, "/").concat(locale.language, "/signup");
var buildGiftCardDownloadUrl = (locale, hashPdf) => "/".concat(locale.market, "/").concat(locale.language, "/user/gift-card-download?hashPdf=").concat(hashPdf);
var buildSignupPaypalExpressUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/signup-paypal-express");
var buildSignupPaypalExpressPendingUrl = locale => "".concat(locale.market, "/").concat(locale.language, "/t/signup-paypal-express-pending");
var buildSignupPaypalExpressCanceledUrl = locale => "".concat(locale.market, "/").concat(locale.language, "/t/signup-paypal-express-canceled");
export var urlBuilder = {
  buildCartUrl,
  buildCgvUrl,
  buildCguUrl,
  buildShippingUrl,
  buildHomeUrl,
  buildLoginUrl,
  buildMerchantUrl,
  buildMyAccountUrl,
  buildPaymentUrl,
  buildMkpConfirmationUrl,
  buildPaymentPaypalPendingUrl,
  buildPaymentPaypalCanceledUrl,
  buildPaymentConfirmedUrl,
  buildPaymentRefusedUrl,
  buildProductUrl,
  buildGiftCardUrl,
  buildCustomProductUrl,
  buildSignupUrl,
  buildSignupPaypalExpressUrl,
  buildSignupPaypalExpressPendingUrl,
  buildSignupPaypalExpressCanceledUrl
};
export default {
  methods: {
    buildHomeUrl,
    buildCartUrl,
    buildCategoryUrl,
    buildCustomProductUrl,
    buildContactFormUrl,
    buildEditoUrl,
    buildFaqUrl,
    buildGiftCardDownloadUrl,
    buildLoginUrl,
    buildMerchantUrl,
    buildProductUrl,
    buildGiftCardUrl,
    buildReturnFormUrl,
    buildSearchUrl,
    buildStaticUrl
  }
};